<template>
    <div>
        <div class="row">
            <!-- Tabel Tunggakan-->
            <div class="col-lg-12">
                <div class="dx-card px-3 py-4 mt-3">
                    <div style="height: calc(100vh - 200px);">

                        <DxDataGrid
                            :dataSource="pemakaianNolStore.datasourcePemakaianNol"
                            :allow-column-reordering="true"
                            :allow-column-resizing="true"
                            :column-auto-width="true"
                            :show-borders="true"
                            :hover-state-enabled="true"
                            :show-column-lines="true"
                            :word-wrap-enabled="true"
                            :row-alternation-enabled="true"
                            :remote-operations="true"
                            style="height:100%"
                            :sorting="{mode: 'multiple'}"
                            :scrolling="{mode: 'virtual',rowRenderingMode: 'virtual',columnRenderingMode: 'virtual',useNative: true}"
                        >

                            <DxToolbar>
                                <DxItem location="before">
                                    <h5><span>Pemakaian Nol</span></h5>
                                </DxItem>
                                <DxItem location="before">
                                    <DxSelectBox
                                        width="160"
                                        :items="commonStore.last24Months"
                                        :input-attr="{ 'aria-label': 'Group' }"
                                        display-expr="text"
                                        value-expr="value"
                                        v-model:value="bacameterStore.selectedBulanBacaDataGrid"
                                        label="Sampai Bulan"
                                        :label-mode="'floating'"
                                    />
                                </DxItem>
                                <DxItem location="before">
                                    <DxNumberBox
                                        v-model:value="bacameterStore.selectedRangeDataGrid"
                                        :min="3"
                                        :max="9"
                                        :width="100"
                                        :show-spin-buttons="true"
                                        label="Jml Bulan"
                                        :label-mode="'floating'"
                                    />
                                </DxItem>

                                <DxItem location="before">
                                    <DxButton
                                        :width="120"
                                        text="Muat"
                                        type="success"
                                        styling-mode="contained"
                                        @click="pemakaianNolStore.onMuatButtonClick"
                                    />
                                </DxItem>

                                <DxItem location="after" name="columnChooserButton">
                                </DxItem>
                                <DxItem location="after" name="exportButton">
                                </DxItem>
                            </DxToolbar>
                            <DxExport :enabled="true"/>

                            <DxPaging
                                :enabled="true"
                                :page-size="200"
                            />
                            <DxPager
                                :visible="true"
                                :showPageSizeSelector="false"
                                :showNavigationButtons="false"
                                :show-info="true"
                                :infoText="'Page {0} of {1} ({2} items)'"
                            />
                            <DxFilterRow :visible="true" apply-filter="auto"/>
                            <DxScrolling mode="virtual"/>
                            <DxSelection mode="single"/>
                            <DxHeaderFilter :visible="true"/>
                            <DxColumnChooser :enabled="true"/>

                            <DxColumn
                                dataField="nosbg"
                                caption="Nosbg"
                                :allowHeaderFiltering="false"
                            />

                            <DxColumn
                                dataField="kantor"
                                caption="Kantor"
                                :allowHeaderFiltering="true"
                                :header-filter="{dataSource: commonStore.kantorHeaderFilters}"                            />

                            <DxColumn
                                dataField="gol"
                                caption="Gol"
                                :allowHeaderFiltering="true"
                                :header-filter="{dataSource: commonStore.golonganHeaderFilters}"
                            />

                            <DxColumn
                                dataField="rayon"
                                caption="Rayon"
                                :allowHeaderFiltering="true"
                                :header-filter="{dataSource: commonStore.rayonHeaderFilters}"
                            />

                            <DxColumn
                                dataField="alamat"
                                caption="Alamat"
                                :allowHeaderFiltering="false"
                            />

                            <DxColumn
                                dataField="pembaca"
                                caption="Pembaca"
                                :allowHeaderFiltering="false"
                            />

                            <DxColumn
                                dataField="kelainan"
                                caption="Kelainan"
                                :allowHeaderFiltering="false"
                            />

                            <DxColumn
                                dataField="kodekelainan"
                                caption="Kode Kelainan"
                                :allowHeaderFiltering="false"
                                :visible="false"
                            />


                        </DxDataGrid>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<style lang="scss">
</style>
<script setup>
import {
    DxColumn,
    DxColumnChooser, DxDataGrid,
    DxExport,
    DxFilterRow,
    DxHeaderFilter,
    DxItem,
    DxPager, DxPaging, DxScrolling,
    DxSelection,
    DxToolbar
} from "devextreme-vue/data-grid";
import { DxSelectBox } from 'devextreme-vue/select-box';
import { DxNumberBox } from 'devextreme-vue/number-box';
import { DxButton } from 'devextreme-vue/button';

//import {useFormaterStore} from "@/store/utility/formatter-store";
import {usePemakaianNolStore} from "@/store/views/pemakaian-nol-store";
import {useCommonStore} from "@/store/utility/common-store";
import {onMounted} from "vue";
import {useBacameterStore} from "@/store/models/bacameter-store";

const pemakaianNolStore = usePemakaianNolStore();
const commonStore = useCommonStore();
const bacameterStore = useBacameterStore();
//const formaterStore = useFormaterStore();

onMounted(pemakaianNolStore.initialized);
</script>